function moveInstallmentTemplate() {
  const installmentElement = document.querySelector('[id^="product-form-installment-"]');
  const installmentContainer = installmentElement || null;
  const shopifyPaymentButton = document.querySelector('.shopify-payment-button');
  
  if (installmentContainer && shopifyPaymentButton) {
    const acceleratedCheckout = shopifyPaymentButton.querySelector('shopify-accelerated-checkout');
    
    if (acceleratedCheckout && acceleratedCheckout.shadowRoot) {
      const walletWrapper = acceleratedCheckout.shadowRoot.querySelector('.wallet-button-wrapper');
      
      if (walletWrapper) {
        const allSlots = walletWrapper.querySelectorAll('slot');
        
        let targetSlot = walletWrapper.querySelector('slot[name="more-options"]');
        
        if (targetSlot) {
          walletWrapper.insertBefore(installmentContainer, targetSlot);
        } else if (allSlots.length > 1) {
          walletWrapper.insertBefore(installmentContainer, allSlots[allSlots.length - 1]);
        } else {
          walletWrapper.appendChild(installmentContainer);
        }
        
        installmentContainer.style.marginTop = '10px';
        
        // Add rounded border to ShopPay button (navigate through nested shadow roots)
        const shopPayButton = acceleratedCheckout.querySelector('shop-pay-wallet-button[slot="button"]');
        if (shopPayButton && shopPayButton.shadowRoot) {
          const gravityButton = shopPayButton.shadowRoot.querySelector('gravity-button.accelerated-checkout-button');
          if (gravityButton && gravityButton.shadowRoot) {
            const actualButton = gravityButton.shadowRoot.querySelector('button.gravity-button');
            if (actualButton) {
              actualButton.style.borderRadius = '2px';
            }
          }
        }
      }
    }
  }
}

function positionShareButton() {
  const shareButton = document.querySelector('share-button');
  
  if (!shareButton) return;
  
  // Check if slideshow arrows are hidden to determine if it's mobile
  const slideshowArrows = document.querySelector('.custom-slideshow');
  const isMobile = slideshowArrows && window.getComputedStyle(slideshowArrows).display === 'none';
  
  if (isMobile) {
    // Mobile: position relative to product media
    const productMedia = document.querySelector('.product__media.media');
    
    if (productMedia) {
      // Only move if share button is not already a child of product media
      if (shareButton.parentNode !== productMedia) {
        productMedia.appendChild(shareButton);
        
        // Make media container relative positioned and allow overflow
        productMedia.style.position = 'relative';
        productMedia.style.overflow = 'visible';
        
        // Style the share button for mobile
        shareButton.style.position = 'absolute';
        shareButton.style.bottom = '23px';
        shareButton.style.left = '10px';
        shareButton.style.top = 'auto';
        shareButton.style.zIndex = '10';
        shareButton.style.backgroundColor = '#000000b3';
        shareButton.style.color = '#afafaf';
        shareButton.style.borderRadius = '8px';
        shareButton.style.padding = '8px';
        shareButton.style.pointerEvents = 'auto';
        shareButton.style.height = 'auto';
        shareButton.style.width = '68px';
      }
    }
  } else {
    // Desktop: position relative to custom slideshow
    const customSlideshow = document.querySelector('.custom-slideshow');
    
    if (customSlideshow) {
      const parent = customSlideshow.parentNode;
      
      // Only move if share button is not already a child of the parent
      if (shareButton.parentNode !== parent) {
        parent.appendChild(shareButton);
        
        // Make parent container relative positioned
        parent.style.position = 'relative';
        
        // Style the share button for desktop
        shareButton.style.position = 'absolute';
        shareButton.style.bottom = '10px';
        shareButton.style.right = '15%';
        shareButton.style.top = 'auto';
        shareButton.style.zIndex = '10';
        shareButton.style.backgroundColor = '#000000b3';
        shareButton.style.color = '#afafaf';
        shareButton.style.borderRadius = '8px';
        shareButton.style.padding = '8px';
        shareButton.style.pointerEvents = 'auto';
      }

      if (window.innerWidth >= 1380) {
        shareButton.style.right = '15%';
      } else {
        shareButton.style.right = '10px';
      }
    }
  }
}

// Single observer handles all dynamic changes
const observer = new MutationObserver(() => {
  // Always try both functions on any DOM change
  moveInstallmentTemplate();
  positionShareButton();
});

// Start observing immediately
observer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['class']
});

// Listen for window resize to update share button positioning
window.addEventListener('resize', () => {
  positionShareButton();
});
